"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4052],{

/***/ 4052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i7": function() { return /* binding */ AskQuestion; },
  "sS": function() { return /* binding */ CollapsableRotate; },
  "kT": function() { return /* binding */ CollapsableRotateAnimate; },
  "Oq": function() { return /* binding */ CropText; },
  "zV": function() { return /* binding */ LargeCollapsableRotate; }
});

// UNUSED EXPORTS: Collapsable

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/html-preview/dist/index.js
var dist = __webpack_require__(2795);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 1 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(1463);
// EXTERNAL MODULE: ./public/img/triangle-down.svg
var triangle_down = __webpack_require__(4648);
;// CONCATENATED MODULE: ./public/img/arrow-up.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 14 9",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.13 8.933 13.5 7.54 7 .933.5 7.54l1.37 1.393L7 3.72l5.13 5.213Z"
  })));
};
/* harmony default export */ var arrow_up = (SvgArrowUp);
// EXTERNAL MODULE: ./components/styled/typography.js
var typography = __webpack_require__(2068);
// EXTERNAL MODULE: ./lib/consts.ts
var consts = __webpack_require__(9006);
// EXTERNAL MODULE: ./utils/index.tsx
var utils = __webpack_require__(6535);
// EXTERNAL MODULE: ./components/icon/icon.tsx
var icon = __webpack_require__(1600);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
;// CONCATENATED MODULE: ./components/collapsable/collapsable.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

 // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore











function Collapsable(_ref) {
  var head = _ref.head,
      body = _ref.body;

  var _useState = (0,react.useState)(false),
      isCollapse = _useState[0],
      setIsCollapse = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      onClick: function onClick() {
        return setIsCollapse(!isCollapse);
      },
      children: head
    }), isCollapse && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: body
    })]
  });
}

var _ref3 =  true ? {
  name: "1ks9uvr",
  styles: "display:flex;justify-content:space-between;align-items:center;width:100%"
} : 0;

var _ref4 =  true ? {
  name: "110i5o6",
  styles: "padding-right:16px"
} : 0;

function CollapsableRotate(_ref2) {
  var head = _ref2.head,
      body = _ref2.body;

  var _useState2 = (0,react.useState)(false),
      isCollapse = _useState2[0],
      setIsCollapse = _useState2[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
      css: _ref3,
      type: "button",
      onClick: function onClick() {
        return setIsCollapse(!isCollapse);
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: _ref4,
        children: head
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(triangle_down/* default */.Z, {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
            width: 12,
            height: 12,
            fill: 'black',
            transform: isCollapse ? 'rotate(180deg)' : 'none'
          },  true ? "" : 0,  true ? "" : 0)
        })
      })]
    }), isCollapse && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: body
    })]
  });
}

var _ref6 =  true ? {
  name: "1h112cj",
  styles: "display:inline-flex;justify-content:flex-start;align-items:center;cursor:pointer"
} : 0;

var _ref7 =  true ? {
  name: "110i5o6",
  styles: "padding-right:16px"
} : 0;

function CollapsableRotateAnimate(_ref5) {
  var head = _ref5.head,
      body = _ref5.body,
      isCollapse = _ref5.isCollapse,
      callback = _ref5.callback;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
      css: _ref6,
      type: "button",
      onClick: callback,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: _ref7,
        children: head
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(triangle_down/* default */.Z, {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
            width: 12,
            height: 12,
            fill: 'black',
            transform: isCollapse ? 'rotate(180deg)' : 'none',
            transition: '0.4s ease-in-out'
          },  true ? "" : 0,  true ? "" : 0)
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
        transform: 'translateZ(0)',
        transition: '0.3s ease-in-out',
        display: 'block',
        maxHeight: isCollapse ? 560 : 0,
        overflow: 'auto',
        paddingLeft: 10,
        marginLeft: '-10px'
      },  true ? "" : 0,  true ? "" : 0),
      children: body
    })]
  });
}

var _ref9 =  true ? {
  name: "st29e1",
  styles: "box-shadow:0 1px 1px rgba(0, 0, 0, 0.05)"
} : 0;

var _ref10 =  true ? {
  name: "grw28s",
  styles: "display:flex;justify-content:space-between;align-items:center;width:100%;height:75px"
} : 0;

function LargeCollapsableRotate(_ref8) {
  var head = _ref8.head,
      body = _ref8.body,
      isCollapse = _ref8.isCollapse,
      callback = _ref8.callback;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: _ref9,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
      css: _ref10,
      type: "button",
      onClick: callback,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: head
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(arrow_up, {
          css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
            width: 14,
            height: 9,
            transform: isCollapse ? 'none' : 'rotate(180deg)',
            fill: '#C7C7CC'
          },  true ? "" : 0,  true ? "" : 0)
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
        transform: 'translateZ(0)',
        transition: '0.3s ease-in-out',
        display: 'block',
        maxHeight: isCollapse ? 10000 : 0,
        overflow: 'hidden',
        paddingLeft: 10,
        marginLeft: '-10px'
      },  true ? "" : 0,  true ? "" : 0),
      children: body
    })]
  });
}

var _ref12 =  true ? {
  name: "22m7g9",
  styles: "border-bottom:1px dashed #000000"
} : 0;

function CropText(_ref11) {
  var text = _ref11.text,
      deskTopCount = _ref11.deskTopCount,
      mobileCount = _ref11.mobileCount;

  var _useState3 = (0,react.useState)(false),
      isAdaptive = _useState3[0],
      setIsAdaptive = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showReadMoreButton = _useState4[0],
      setShowReadMore = _useState4[1];

  (0,react.useEffect)(function () {
    if (window.innerWidth <= consts/* DEVICE_SCREENS.md */.XA.md) {
      setIsAdaptive(true);

      if (dist_default()(text || '', 9e9).length > dist_default()(text, mobileCount).length) {
        setShowReadMore(true);
      } else {
        setShowReadMore(false);
      }
    } else {
      setIsAdaptive(false);

      if (dist_default()(text || '', 9e9).length > dist_default()(text, deskTopCount).length) {
        setShowReadMore(true);
      } else {
        setShowReadMore(false);
      }
    }
  }, [text]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(typography/* StyledText */.q, {
    className: "crop-text",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      dangerouslySetInnerHTML: {
        __html: showReadMoreButton ? (0,utils/* getTextPreview */.sP)(text, isAdaptive ? mobileCount : deskTopCount) : text
      }
    }), showReadMoreButton && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
      onClick: function onClick() {
        return setShowReadMore(false);
      },
      css: _ref12,
      type: "button",
      children: "\u041F\u043E\u043B\u043D\u043E\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435"
    })]
  });
}

var _ref14 =  true ? {
  name: "yeljyt",
  styles: "display:flex;margin-left:9px;max-height:20px;width:10px"
} : 0;

var _ref15 =  true ? {
  name: "mgb3ws",
  styles: "svg{width:22px;height:22px;}display:flex;flex-wrap:wrap;a:not(:last-child){margin-right:12px;margin-bottom:6px;}"
} : 0;

function AskQuestion(_ref13) {
  var socials = _ref13.socials;
  var theme = (0,emotion_element_c39617d8_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    // social-question
    css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({}, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
      display: 'flex',
      justifyContent: 'center'
    }),  true ? "" : 0,  true ? "" : 0),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Collapsable, {
      head: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        // social-question__head
        css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)({
          marginTop: 11,
          cursor: 'pointer',
          display: 'flex',
          color: theme.colors.text,
          marginBottom: '8px',
          fontFamily: 'Golos',
          fontSize: 14,
          fontWeight: 500,
          svg: {
            stroke: theme.colors.text
          },
          textDecoration: 'underline',
          textDecorationStyle: 'dashed'
        },  true ? "" : 0,  true ? "" : 0),
        children: ["\u0417\u0410\u0414\u0410\u0422\u042C \u0412\u041E\u041F\u0420\u041E\u0421", ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: _ref14,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon/* Icon */.J, {
            iconId: "angle-down"
          })
        })]
      }),
      body: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        // social-question__body
        css: _ref15,
        children: socials.results.map(function (social) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: social.url,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon/* Icon */.J, {
              iconId: social.type
            }, "Icon__".concat(social.id))
          }, "Anchor__".concat(social.id));
        })
      })
    })
  });
}

/***/ })

}]);